export default {
  path: '/tbs',
  name: 'tbs',
  component: () => import('../../views/Layout/index'),
  meta: {
    title: '权益优享',
    // keepAlive: false
  },
  children: [
    // {
    //   // 权益优享-运营数据
    //   path: 'operationalData',
    //   name: 'operationalData',
    //   component: () => import('../../views/Tbs/OperationalData/OperationalDataIndex'),
    //   meta: { title: '运营数据', keepAlive: false }
    // },
    {
      // 权益优享-订单管理-订单管理
      path: 'orderManage/order',
      name: 'tbsOrder',
      component: () => import('../../views/Tbs/OrderManage/OrderManageIndex'),
      meta: {title: '订单管理', keepAlive: false}
    },
    {
      // 权益优享-订单管理-订单管理-详情
      path: 'orderManage/orderDetail',
      name: 'tbsOrderDetail',
      component: () => import('../../views/Tbs/OrderManage/OrderManageDetail'),
      meta: {title: '订单详情', keepAlive: false}
    },
    {
      //权益优享-订单管理-预约信息管理
      path: 'orderManage/appointment',
      name: 'tbsAppointment',
      component: () => import('../../views/Tbs/OrderManage/AppointmentIndex'),
      meta: {title: '预约信息管理', keepAlive: false}
    },
    {
      // 权益优享-资金管理-冻结金管理
      path: 'fundManage/frozenFee',
      name: 'tbsFrozenFee',
      component: () => import('../../views/Tbs/FundManage/FrozenFeeManage/FrozenFeeManageIndex'),
      meta: {title: '冻结金管理', keepAlive: false}
    },
    {
      // 权益优享-资金管理-冻结金管理-详情
      path: 'fundManage/frozenFeeDetail',
      name: 'tbsFrozenFeeDetail',
      component: () => import('../../views/Tbs/FundManage/FrozenFeeManage/FrozenFeeManageDetail'),
      meta: {title: '冻结金详情', keepAlive: false}
    },
    {
      // 权益优享-资金管理-直降款管理
      path: 'fundManage/reducedFee',
      name: 'tbsReducedFee',
      component: () => import('../../views/Tbs/FundManage/ReducedFeeManage/ReducedFeeManageIndex'),
      meta: {title: '直降款管理', keepAlive: false}
    },
    {
      // 权益优享-资金管理-直降款管理-详情
      path: 'fundManage/reducedFeeDetail',
      name: 'tbsReducedFeeDetail',
      component: () => import('../../views/Tbs/FundManage/ReducedFeeManage/ReducedFeeManageDetail'),
      meta: {title: '直降款详情', keepAlive: false}
    },
    {
      // 权益优享-分期账单管理-分期账单管理 /tbs/fillManage/fill
      path: 'fillManage/fill',
      name: 'tbsFill',
      component: () => import('../../views/Tbs/FillManage/FillManageIndex'),
      meta: {title: '分期账单管理', keepAlive: false}
    },
    {
      // 权益优享-分期账单管理-分期账单管理-详情
      path: 'fillManage/fillDetail',
      name: 'tbsFillDetail',
      component: () => import('../../views/Tbs/FillManage/FillManageDetail'),
      meta: {title: '分期账单管理详情', keepAlive: false}
    },
    {
      // 权益优享-备案信息-网点商户管理
      path: 'recordInformation/websiteAndMerchants',
      name: 'websiteAndMerchants',
      component: () => import('../../views/Tbs/RecordInformation/websiteAndMerchants'),
      meta: {title: '网点商户管理', keepAlive: false}
    },
    {
      // 权益优享-资金管理-应收款与实收款核对
      path: 'fundManage/check',
      name: 'check',
      component: () => import('../../views/Tbs/FundManage/Check/CheckIndex'),
      meta: {title: '应收款与实收款核对', keepAlive: false}
    },
    {
      // 权益优享-业务退订-撤单管理
      path: 'businessUnsubscribe/orderCancelManage',
      name: 'tbsOrderCancelManage',
      component: () => import('../../views/Tbs/BusiUnsubscribe/OrderCancelManage/OrderCancelManageIndex'),
      meta: { title: '撤单管理', keepAlive: false }
    },
    {
      // 权益优享-业务退订-违约退订管理
      path: 'businessUnsubscribe/orderBreakManage',
      name: 'tbsOrderBreakManage',
      component: () => import('../../views/Tbs/BusiUnsubscribe/OrderBreakManage/OrderBreakManageIndex'),
      meta: { title: '违约退订管理', keepAlive: false }
    },
     {
       // 权益优享-业务退订-延期滞纳管理
       path: 'businessUnsubscribe/deferredManage',
       name: 'deferredManage',
       component: () => import('../../views/Tbs/BusiUnsubscribe/DeferredManage/deferredManage'),
       meta: {title: '延期滞纳管理', keepAlive: false}
     },
  ]
}